import React, { Component } from 'react';

import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Hidden from '@material-ui/core/Hidden';

class Navbar extends Component {
  render() {
    return (
      <React.Fragment>
        <AppBar position="static" style={{ backgroundColor: '#5dc8ae', alignItems: 'center' }}>
          <Toolbar style={{ padding: '0.5rem', width: '83.333333%' }}>
            <Hidden only={['xs', 'sm']}>
              <img src="./logo.svg" alt="UCL Logo" style={{ height: '100%', borderRadius: '100%' }} />
              <Grid container wrap="nowrap" spacing={16} style={{ paddingLeft: '0.5rem' }}>
                <Grid item xs>
                  <Typography variant="h4" color="inherit">
                    USPCodeLab Sanca
                  </Typography>
                  <Typography variant="h6" color="inherit" style={{ fontWeight: '300' }}>
                    Ensino, Pesquisa e Extensão pela Inovação Tecnológica na USP
                  </Typography>
                </Grid>
              </Grid>
            </Hidden>
            <Hidden only={['md', 'lg', 'xl']}>
              <Grid container style={{ textAlign: 'center' }}>
                <Grid item xs={12}>
                  <img src="./logo.svg" alt="UCL Logo" style={{ height: '100%', borderRadius: '100%' }} />
                </Grid>
                <Grid item xs={12}>
                  <Typography variant="h3" color="inherit">
                    USPCodeLab Sanca
                  </Typography>
                  <Typography variant="h5" color="inherit">
                    Ensino, Pesquisa e Extensão pela Inovação Tecnológica na USP
                  </Typography>
                </Grid>
              </Grid>
            </Hidden>
          </Toolbar>
        </AppBar>
      </React.Fragment>
    );
  }
}

export default Navbar;